module.exports = __webpack_public_path__ + "img/icon-appointment-history.28fb56fe.png";